var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoolie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 769.2 952.1",
    style: {
      enableBackground: "new 0 0 769.2 952.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0048DD;}\n\t.st1{fill:#00DCFF;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_00000070117140648420977910000008239564307756604050_);}\n\t.st4{fill:url(#SVGID_00000168074840596352274190000014400525491768150718_);}\n\t.st5{fill:url(#SVGID_00000112617546182732912480000012380775938856527779_);}\n\t.st6{fill:url(#SVGID_00000096765712988830401820000009377513209909409980_);}\n\t.st7{fill:url(#SVGID_00000036973760817323279740000001028547927884141483_);}\n\t.st8{fill:#001485;}\n\t.st9{fill:#176BDC;}\n\t.st10{fill:url(#SVGID_00000137826940584080063750000007152121008230957714_);}\n\t.st11{fill:#FFFFFF;}\n\t.st12{fill:#00ACFF;}\n\t.st13{opacity:0.2;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.3,307.4c0,0-33.3-3.8-28.2,33.3s28.9,85.9,109.7,78.9l1.9-87.8L140.3,307.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.3,306.1c0,0-98.8-119.9-141.1-116.7c-42.3,3.2-15.4,103.9,37.2,127.6s84,23.7,84,23.7L240.3,306.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M510.9,335.6c0,0,114.8-72.5,161.6-54.5c46.8,18,4.5,116.7-62.8,124.4s-105.8-6.4-105.8-6.4L510.9,335.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.7,260.6c0,0,84.6-150.7,125-151.3c40.4-0.6,98.8,151.3-68,223.8L466.7,260.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M611.5,529c-2.3-31.1-37.3-58.3-69.1-69.9c-17.5-6.4-45.2-8.5-73.9-6c14-10.2,27.1-22.7,38.9-38.3 c58.3-76.9-7-144.5-43.5-160c-70.8-30.1-181.7-49.7-240,55.9s25.6,163.1,79.2,174.8c0.7,0.2,1.5,0.3,2.2,0.4 c-7.2,5.1-13.7,11.1-19.4,17.7l3.2-6.5c-97.9,3.1-138.3,73-144.5,101s6.2,27.2,8.5,51.3c2.3,24.1,17.9,3.1,24.1,28.7 c6.2,25.6,34.2,11.7,34.2,11.7s9.3-9.3,24.1-59.8c14.8-50.5-16.3-16.3-6.2-55.1c10.1-38.8,37.3-31.8,37.3-31.8l0.8-1.6 c-1.3,7-1.7,14.3-0.8,21.8c2.3,19.1,12.4,33.2,27.2,42.3l-1.3-0.3c0,0-45,91.1,6.2,152.7c51.3,61.6,103.5,8.9,67.3-54.9 c-26.4-46.6-24.3-85.4-24.3-85.4l-0.8-0.2c11.1,0,22.8-1.6,34.7-4.7l-5.4,2.3c0,0,23.3,93.2,74.6,128.4c51.3,35.2,116-1.4,70.9-63.2 c-28-38.3-62.1-38.8-98.4-84.9l-2.3,1c32.3-29.5,24.7-84.9,24.1-88.6c19.8,3.2,40.4,12.1,39.6,35.3c-1.6,44.3,31.8,41.9,41.2,66.8 c9.3,24.9,33.4,32.6,50.5,17.9c17.1-14.8-0.8-17.1,14-50.5C599.1,543.8,613.8,560.1,611.5,529z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.1,545.9H323c0,0,2.3-10.4,9.6-20.8c5.6-8,17.3-18.3,17.3-18.3c-18,0-49.4,7.1-49.4,7.1 c-14.1,28.9-11.5,53.2-11.5,53.2l20.5-5.8c0,0-3.8,16-1.9,34C307.6,595.3,323,563.2,346.1,545.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 531.5916,
    y1: 274.7254,
    x2: 595.7153,
    y2: 195.8533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05505952,
    style: {
      stopColor: "#00DCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B8D9"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M507.9,277.5c0,0,25.7-17,51.5-78.5c26-62,48.4-65.6,55.3-13c8.7,65.9-74.5,114.5-74.5,114.5 s59.9-56.8,55-107.9c0,0-4.5,45.2-52.6,79.5c0,0,15.9-28.7,16.4-41.2C558.8,231,524.7,273.2,507.9,277.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062891842901358309200000009741559598278858398_",
    gradientUnits: "userSpaceOnUse",
    x1: 583.563,
    y1: 385.0188,
    x2: 654.7404,
    y2: 330.5137
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05505952,
    style: {
      stopColor: "#00DCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B8D9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062891842901358309200000009741559598278858398_)"
    },
    d: "M557.9,375c34.6-18.8,79.8-78,105.5-75 s4.6,77-55.1,90c0,0,19.2-13.5,32.2-33.2c0,0-38.5,28.9-68.3,37c0,0,11.1-7.7,21.2-24c0,0-28.4,20.2-51,20.7c0,0,16.4-1.9,36.6-20.7 L557.9,375z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174566467563851441660000012732365628654163097_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.0737,
    y1: 304.4561,
    x2: 105.7438,
    y2: 249.3098
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05505952,
    style: {
      stopColor: "#00DCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B8D9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174566467563851441660000012732365628654163097_)"
    },
    d: "M195.7,314c0,0-21.2-16.1-41.7-39.3 c-23.2-26.4-46.2-60.1-52.6-57.8c-12,4.3-7.2,51.5,16.8,73.6s51.5,29.8,51.5,29.8s-56.5-35.1-62.3-71c0,0,23.4,39.4,57,56.1 L132.2,263C132.2,263,165.4,300.5,195.7,314z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018228287436503138690000000986645103189676928_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.9808,
    y1: 389.9499,
    x2: 118.0406,
    y2: 346.3458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05505952,
    style: {
      stopColor: "#00DCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B8D9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018228287436503138690000000986645103189676928_)"
    },
    d: "M198.1,401.5c0,0-26.9-18.3-46.2-45.2 s-33.2-32.7-28.9-3.4c4.3,29.3,27.9,53.9,64.9,56.3c0,0-20.7-6.7-32.2-24C155.8,385.1,172.2,399.6,198.1,401.5z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M447.7,265c0,0,15.4-88.1-11.1-133.8c0,0-2.8,72.8-52.2,93.7l14.2,17.1c0,0-1.9-90.4-64.4-182.4 c0,0,8.8,91.7-16.4,138.2l55.8,57.1c0,0-84.6-136.6-167.4-173.1c0,0,40.3,117.3,43.1,209.8L447.7,265z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080186510151365220740000014554540205001896350_",
    gradientUnits: "userSpaceOnUse",
    x1: 505.2357,
    y1: 741.4119,
    x2: 457.7842,
    y2: 686.2656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05505952,
    style: {
      stopColor: "#00DCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B8D9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080186510151365220740000014554540205001896350_)"
    },
    d: "M413.2,690.2c0,0,35,72.3,89.1,57.7 c50-13.5,0-77.6-16-87.8c0,0,16,38.5,12.2,53.9c0,0-16-35.3-43-52.6c0,0,15.4,37.8,18,47.5c0,0-31.4-19.9-52.6-43 c0,0,9,28.2,19.9,42.3C440.7,708.2,424.1,701.1,413.2,690.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024685825944175800060000009235352847098885051_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.6047,
    y1: 766.1783,
    x2: 319.7263,
    y2: 703.9783
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05505952,
    style: {
      stopColor: "#00DCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B8D9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024685825944175800060000009235352847098885051_)"
    },
    d: "M278.8,687.2c3.4,56.7,41.8,91.4,65.4,89.9 c23.6-1.4,32.7-39.4,15.9-65.4c0,0,3.4,20.7,0.5,30.8c0,0-8.7-27.9-23.1-44.7c0,0,3.4,41.8,2.4,53.9c0,0-30.3-44.7-34.6-77.4 c0,0-8.2,29.3-3.4,54.3C301.8,728.5,284.5,705,278.8,687.2z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M322.4,612.9c0,0,26.3,18,65.4-3.5C387.8,609.4,345.1,617.7,322.4,612.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M267.1,263c0,0-60.8,40.4-48.8,127c9.8,70.7,71.2,99.6,146.7,89c0,0-78.9,26.5-132.7-26.9S214,288,267.1,263z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M427.1,466.4c0,0,66.9-10.8,87.7-87.2c24.4-89.8-58.5-127.5-58.5-127.5s93.5,33.6,74.3,119.6 S427.1,466.4,427.1,466.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M245.2,280.1c0,0-3.1-61.1-38.9-198.4c0,0,76.3,32.1,134,125c0,0-41.8-58.4-96.9-83.4c0,0,17.5,60.9,14.3,145.1 L245.2,280.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M321.4,179.2c0,0,13.8-43.1,12.8-119.6c0.3,0.9,67.6,77.3,64.4,178.3c0,0-6.3-73.5-49.1-128.6 c0,0-3.5,40.1-18,84.1L321.4,179.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M397.9,211.5c0,0,26.2-17.7,38.7-80.3c0,0,25.4,42.7,13.2,118c0,0,3.2-59.3-11.8-84.4c0,0-14.2,37.5-39.7,54.6 L397.9,211.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M410.2,599.2c0,0,30.4-22.1,24.5-86.9l-18.7-2.1c0,0,26-8.7,47.4,0.8c29,12.8,10.8,42.2,28.7,69.8 c0,0-15.4-12.6-19-39.7c-3.6-27.1-32.4-28.8-32.4-28.8S449.1,579,410.2,599.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M365,618.2c0,0,33.3,144.8,127,138.6c0,0-78.9,2.6-119.4-140.8L365,618.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M420,592.3c0,0,20.4,31.7,67.5,60.3c0,0-46.6-20.4-72.5-56.3L420,592.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M341,617.4c0,0-11.8,34.4,14.1,74.6c23.4,36.2,23.3,61.2,16.2,78.2c0,0,22.6-25-4.8-70.7 c-22-36.7-22.1-60.4-19.7-82.5L341,617.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M314,485.4c0,0-43.3,23.5-42.7,72.1c0.4,33,26.9,49,26.9,49s-54.8-16.8-25.1-84c10.3-23.4,32.4-40.9,32.4-40.9 L314,485.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M578.2,609.4c-16-45.2-11.2-80.5-11.2-80.5s1.6,31.7,9.3,45.5c0,0,3.5-18.6,20.2-25.6 c16.7-7.1,6-69.3-62.4-92.2c0,0,71.7,18.6,77.4,72.4c3,27.8-16.9,27.1-27.2,48.2C579.8,586.3,578.2,609.4,578.2,609.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M528.1,335.6c0,0,15.4-9.1,53.4-37.3c0,0,75.1-41.9,104.6-6.9c0,0-30.6-26.8-81.1,8.4 c-50.5,35.2-83.5,98.1-83.5,98.1L528.1,335.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M495.2,274.6c0,0,27.6-12.6,43.9-60.2c16.4-47.6,31.3-92.3,56.3-95.2s37.7,36.5,40,68.3c0,0-0.7-73.2-43.7-78.2 c-43-5-115.6,121-124.3,147.4L495.2,274.6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M92.3,270.8c-12.8-38.2-13.2-72.1,16-58.1c25.3,12.2,42.5,42.1,64.7,67.4s45.4,40.1,45.4,40.1l14.3-23.7 c0,0-71.2-93.1-123.1-107.1C57.5,175.3,76.7,247.3,92.3,270.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M124.5,310c23.5,17.6,63.9,33.4,87.3,41.2l-2.2,40.9c0,0-25.7-10.5-50.2-40.9c-24.5-30.4-50.2-39-47.3-10.5 C112.1,340.7,106.1,314.9,124.5,310z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M211.5,689.8c0,0-17.2,10.8-24.9-10.8c-7.7-21.6-5.8-35.1-5.8-35.1s-6.9,19.1-17.8,8.7 c-10.9-10.4,2.4-14.2-11.5-32.6c-13.9-18.4,20.6-79.2,56.5-100.5c0,0-61.8,31.6-67.1,97.5c-1.3,16.4,10.8,16.1,13.3,38.1 s13.7,7.7,27.6,32.6C195.7,712.7,211.5,689.8,211.5,689.8z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M227.4,586.2c0,0-3.3-51.1,41.7-53.2l-2.4,10C266.7,543,235.4,540.6,227.4,586.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M289.4,602.5c0,0-42.7,83.1,0.9,143.6c0,0-35.3-62.3,4.8-141.7L289.4,602.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M417.8,536.7c9.5,7.7,4.1,34.1-9.5,35S401.7,523.5,417.8,536.7z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M387.8,567.4c-0.9-8,12.9,3.8,10,7.7C394.8,579,388.9,577,387.8,567.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M180.4,556.7c8.8-3.6,4.4,25.1-4.3,29.6C167.5,590.7,169.9,561,180.4,556.7z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M162.4,583.7c3.5-4.2,6.3,13.8,0,15.5C156.2,600.9,158.5,588.4,162.4,583.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000143607198625465711510000016827318364255713944_",
    cx: 358.8523,
    cy: 352.4644,
    r: 144.0818,
    fx: 341.7055,
    fy: 272.7321,
    gradientTransform: "matrix(0.9758 -0.2187 0.151 0.6736 -44.5237 193.5155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0048DD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143607198625465711510000016827318364255713944_)"
    },
    d: "M274.3,264.9 c82.7-47.5,185.6-33.3,215.6,59.6s-104.6,161-197.9,136S210.8,301.3,274.3,264.9z"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.4,317c0,0,7,12.4,9.5,25.7c4.8,25.6-3.7,39.6-18.4,39.8c-27.6,0.3-27.6-39.1-27.6-39.1 S377.5,324.1,397.4,317z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.5,349.3c0,0-5.8,21.2-0.2,34.6c5.5,13.5,19.7,19,26.9,5.5c7.2-13.5,4.8-20.2,4.8-20.2L252.5,349.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M349.6,444.8c0,0,55.3-11.1,98.1-49.1c0,0-1.5,51.7-43.3,63C374.2,466.9,349.6,444.8,349.6,444.8z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M430.5,409.2c0,0,6,14.7-12.7,24.8c0,0,14-11.7,16.5,3.1c-14.8,23.4-49.9,37.2-84.8,7.6 C349.6,444.8,392.9,434.3,430.5,409.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M349.6,354.8c0,0,15.7-35.5,58.6-47.6L349.6,354.8z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M240.3,343c0,0,34.8-2.3,51.6,31.2L240.3,343z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M459.3,409.2c0,0-2,28.4-24.5,43.8C434.7,452.9,467.5,441.9,459.3,409.2z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M340.3,435.4c0,0,27.9-5.5,67.9-26.2C408.2,409.2,360.8,422.2,340.3,435.4z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M413.8,349.7c0,0,3,32.1-21.6,36.9C392.2,386.6,430.1,396.8,413.8,349.7z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M424.4,356c0,0-0.5,25-32.2,30.5C392.2,386.6,427.1,398.6,424.4,356z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M245.3,368.6c0,0-2.2,23.3,15.6,31.2C260.9,399.8,236.6,401.9,245.3,368.6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M394.5,328.2c0,0,13.1,32.7,1.9,46C396.4,374.2,398.1,342.5,394.5,328.2z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M279.9,371.3c0,0-1.1,19.9-12.8,20.8C267.1,392.1,275.3,385.3,279.9,371.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M487.5,295.8c14.4,3.3,21.6,16,22.8,44.9c1.2,28.9-16.1,44.7-33.4,10.5C459.6,317,475.8,293.2,487.5,295.8z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M443.4,277.5c12.5-9.8,30.2,7.5,23.2,18.2C459.7,306.3,430.4,287.7,443.4,277.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoolie);
export default __webpack_public_path__ + "static/media/zoolie.387c681cd415389eeb3c31a07da109b8.svg";
export { ForwardRef as ReactComponent };